/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { PaymentConfigBehavior } from './PaymentConfigBehavior';

/**
 * Contains attributes relevant for all rules and rules which don't require a value (NULL, NOT_NULL).
 */
export type ConfigurationFieldRuleBase = {
    /**
     * Name of the rule.
     */
    name: string;
    /**
     * List of available rules.
     */
    rule: ConfigurationFieldRuleBase.rule;
    /**
     * Variables used for replacement in the rule message.
     */
    variables: Array<any>;
    /**
     * List of behaviors provide field with extended features that are not covered by the configuration.
     */
    behaviors?: Array<PaymentConfigBehavior> | null;
};

export namespace ConfigurationFieldRuleBase {

    /**
     * List of available rules.
     */
    export enum rule {
        NULL = 'NULL',
        NOT_NULL = 'NOT_NULL',
        MIN = 'MIN',
        MIN_LENGTH = 'MIN_LENGTH',
        MAX = 'MAX',
        MAX_LINES = 'MAX_LINES',
        MAX_LENGTH = 'MAX_LENGTH',
        MAX_LENGTH_PER_LINE = 'MAX_LENGTH_PER_LINE',
        ALLOWED_CHARACTERS = 'ALLOWED_CHARACTERS',
        IN = 'IN',
        IN_RANGE = 'IN_RANGE',
        NOT_IN = 'NOT_IN',
        NOT_IN_RANGE = 'NOT_IN_RANGE',
        CONTAINS = 'CONTAINS',
        HR_REFERENCE_NUMBER = 'HR_REFERENCE_NUMBER',
        MODULO11 = 'MODULO11',
        MODULO97 = 'MODULO97',
    }


}

